import { Account, FeeToken } from 'types';

export const CANTON_CHAIN_ID = '0x63616e746f6e3a6d61696e6e6574';

export const ETH_TOKEN_ADDR =
  'DSO::1220b1431ef217342db44d516bb9befde802be7d8899637d290895fa58880f19accc';

export const TOKENS: any = {
  [CANTON_CHAIN_ID as string]: {
    'DSO::1220b1431ef217342db44d516bb9befde802be7d8899637d290895fa58880f19accc':
      {
        coingeckoId: 'canton-network',
      },
    '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d': {
      coingeckoId: 'starknet',
    },
  },
};

export const DECIMALS_DISPLAYED_MAX_LENGTH = 11;

export const COINGECKO_API = 'https://api.coingecko.com/api/v3/';

export const STARKNET_MAINNET_EXPLORER = 'https://ccexplorer.io/';

export const EXPLORER_API = 'https://api.ccexplorer.io/api';


export const SNAPS_DOC_URL = 'https://docs.metamask.io/guide/snaps.html';

export const STARKNET_ADDRESS_LENGTH = 66;

export const ASSETS_PRICE_REFRESH_FREQUENCY = 120000;

export const ESTIMATE_FEE_REFRESH_FREQUENCY = 3000;

export const ESTIMATE_FEE_CACHE_DURATION = 60000;

export const INPUT_MAX_LENGTH = 100;

export const POPOVER_DURATION = 3000;

export const TRANSACTIONS_REFRESH_FREQUENCY = 60000;

export const TOKEN_BALANCE_REFRESH_FREQUENCY = 60000;

export const OFFERS_REFRESH_FREQUENCY = 60000;

export const TIMEOUT_DURATION = 10000;

export const MIN_ACC_CONTRACT_VERSION = [0, 3, 0];

export const defaultAccount = {
  address: '0xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  addressIndex: 0,
} as Account;

export const DEFAULT_FEE_TOKEN = FeeToken.CC;

export const MIN_METAMASK_VERSION = '12.5.0';

export const DENY_ERROR_CODE = 113;

// Account name length range - [min, max]
export const ACCOUNT_NAME_LENGTH = [1, 20];
